import {Col, Row} from '@jetbrains/ring-ui/components/grid/grid'
import classNames from 'classnames'
import * as React from 'react'

import styles from './CountRow.css'

type Props = {
  count1: number | null | undefined
  count2: number | null | undefined
  changed?: boolean | null | undefined
}

const renderCol = (count: number | null | undefined, changed: boolean | null | undefined) => (
  <Col xs={6}>
    {count != null && (
      <div className={styles.wrapper}>
        {'Count: '}
        <span
          className={classNames({
            [styles.changed]: changed === true,
          })}
        >
          {count}
        </span>
      </div>
    )}
  </Col>
)

function CountRow({count1, count2, changed}: Props) {
  return (
    <Row className={styles.row}>
      {renderCol(count1, changed)}
      {renderCol(count2, changed)}
    </Row>
  )
}

export default CountRow
